"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any, no-dupe-class-members , @typescript-eslint/explicit-module-boundary-types */
const defaultConfig_1 = __importDefault(require("./defaultConfig"));
const utils_1 = require("./utils");
const middlewares_1 = require("./middlewares");
const axios_1 = __importDefault(require("axios"));
const coreMiddlewares = [
    middlewares_1.muteUnhandledRejectionError,
    middlewares_1.debounce,
    middlewares_1.jwt,
    middlewares_1.cancelable,
    middlewares_1.cancelWhenRouteChanged,
    middlewares_1.cache,
    middlewares_1.bigIntJson,
    middlewares_1.request,
];
class Request extends axios_1.default.Axios {
    constructor(config = {}) {
        // Axios 实例配置
        super(utils_1.mergeGlobalConfig(axios_1.default.defaults, config));
        this._middlewares = [];
        // Request 实例配置
        this._config = utils_1.mergeGlobalConfig(Request._config, config);
        this._middlewares.push(...Request._middlewares);
    }
    static config(config) {
        Request._config = utils_1.mergeGlobalConfig(defaultConfig_1.default, config);
    }
    static use(middleware) {
        Request._middlewares.push(middleware);
    }
    static resetConfig() {
        Request._config = defaultConfig_1.default;
        Request._middlewares = [];
    }
    originalRequest(config) {
        return super.request(config);
    }
    config(config) {
        this._config = utils_1.mergeGlobalConfig(this._config, config);
    }
    use(middleware) {
        this._middlewares.push(middleware);
    }
    async request(url, config) {
        var _a;
        let rconfig;
        if (typeof url === 'string') {
            rconfig = config || {};
            rconfig.url = url;
        }
        else {
            rconfig = url || {};
        }
        const _requestConfig = utils_1.extractRequestConfig(this._config);
        const requestConfig = utils_1.mergeRequestConfig(_requestConfig, rconfig);
        let middlewares = requestConfig.raw ? coreMiddlewares : [...this._middlewares, ...coreMiddlewares];
        if ((_a = requestConfig.skipMiddlewares) === null || _a === void 0 ? void 0 : _a.length) {
            const skipMiddlewaresNameSet = new Set(requestConfig.skipMiddlewares);
            middlewares = middlewares.filter(m => (m.id ? !skipMiddlewaresNameSet.has(m.id) : true));
        }
        const context = {
            request: requestConfig,
            response: null,
            error: null,
            instance: this,
        };
        try {
            await utils_1.callWithMiddlewares(context, middlewares, this);
        }
        catch (error) {
            context.error = error;
        }
        if (context.error) {
            throw context.error;
        }
        return context.response;
    }
    async get(url, config) {
        return this.request(Object.assign({ url, method: 'GET' }, config));
    }
    async delete(url, config) {
        return this.request(Object.assign({ url, method: 'DELETE' }, config));
    }
    async head(url, config) {
        return this.request(Object.assign({ url, method: 'HEAD' }, config));
    }
    async options(url, config) {
        return this.request(Object.assign({ url, method: 'OPTIONS' }, config));
    }
    async post(url, data, config) {
        return this.request(Object.assign({ url, method: 'POST', data }, config));
    }
    async patch(url, data, config) {
        return this.request(Object.assign({ url, method: 'PATCH', data }, config));
    }
    async put(url, data, config) {
        return this.request(Object.assign({ url, method: 'PUT', data }, config));
    }
    getUri(config) {
        return utils_1.getUri(utils_1.mergeRequestConfig(this._config, config));
    }
    poll(url, config, options) {
        const _continue = (options === null || options === void 0 ? void 0 : options.continue) || (() => true);
        const interval = options === null || options === void 0 ? void 0 : options.interval;
        let stopped = false;
        let _onResponse, _onError;
        const polling = {
            onResponse: cb => {
                _onResponse = cb;
                return polling;
            },
            onError: cb => {
                _onError = cb;
                return polling;
            },
            stop: () => {
                stopped = true;
            },
        };
        utils_1.freezeObjectField(polling, 'stop');
        utils_1.freezeObjectField(polling, 'onError');
        utils_1.freezeObjectField(polling, 'onResponse');
        const requestConfig = Object.assign(Object.assign({}, (config || {})), { url });
        const executor = async (_requestConfig) => {
            let res = null;
            let err = null;
            try {
                res = await this.request(_requestConfig);
                if (!stopped) {
                    _onResponse && _onResponse(res);
                }
            }
            catch (error) {
                err = error;
                _onError && _onError(error);
            }
            const nextConfig = _continue(_requestConfig, res, err);
            if (!nextConfig || stopped) {
                return;
            }
            if (interval) {
                await utils_1.sleep(interval);
            }
            executor(typeof nextConfig === 'boolean' ? _requestConfig : nextConfig);
        };
        executor(requestConfig);
        return polling;
    }
}
exports.Request = Request;
Request._config = defaultConfig_1.default;
Request._middlewares = [];
exports.default = Request;
//# sourceMappingURL=request.js.map